import _, { isArray } from "lodash";

/**
 * @description - Get repeat adapter name
 * @param spName - Sp name
 * @returns
 */
export const getRPTAdapterName = (spName: string): string => {
  try {
    if (spName?.length) {
      const splitSpName = spName.split("_");
      return splitSpName[splitSpName?.length - 1];
    }
    return "";
  } catch (error) {
    return "";
  }
};

/**
 * @description - Bind the schema for repeat sp
 * @param adapterList - Adapter list
 * @param seletedRPTAdapters - Select adapters
 * @returns
 */
export const setSchemaForRPTAdapters = (
  adapterList: any,
  seletedRPTAdapters: any
): Array<any> => {
  try {
    const tempAdapters: Array<any> = [];
    if (seletedRPTAdapters.length) {
      seletedRPTAdapters?.map((selectAdapter: any) => {
        const adapter = adapterList?.find(
          (adapter: any) => adapter.name == selectAdapter
        );
        tempAdapters.push({
          adapterName: getRPTAdapterName(selectAdapter),
          spName: `[${adapter?.schema}].[${selectAdapter}]`,
        });
      });
    }
    return tempAdapters;
  } catch (error) {
    return [];
  }
};

/**
 * @description - Get category group list
 * @param groupList - Category group list
 * @param groupId - Group id
 * @returns
 */
export const getCategoryGroupName = (groupList: any, groupId: number) => {
  try {
    const group = groupList?.find((group: any) => group.groupId == groupId);
    return group.groupName ?? "";
  } catch (error) {
    return "";
  }
};

/**
 * @description - Filter adapters by sp common name and category group
 * @param adapterList - Sp list
 * @param catrgotyGroupId - selected group id
 * @param isRPTAdapters - Is repeat adapters
 * @returns
 */
export const filterAdapters = (
  adapterList: any,
  catrgotyGroupId: number,
  isRPTAdapters: boolean,
  groups: any
) => {
  try {
    const groupName = getCategoryGroupName(groups, catrgotyGroupId);
    if (isRPTAdapters) {
      const rptAdapters = adapterList?.filter((adapter: any) =>
        adapter?.name?.includes(`USC_DATA_RPT_${groupName}`)
      );
      return rptAdapters;
    } else {
      const standardAdapters = adapterList?.filter(
        (adapter: any) => !adapter?.name?.includes("USC_DATA_RPT")
      );
      return standardAdapters?.filter((adapter: any) =>
        adapter?.name?.includes(`_${groupName}_`)
      );
    }
  } catch (error) {
    return [];
  }
};

/**
 * @description - Get category names
 * @param {any} groupList - Category group list
 * @param {string} groupName - Selected group name
 * @returns {Array<string>}
 */
export const getCategoryNamesByGroup = (
  groupList: any,
  groupName: string
): Array<string> => {
  try {
    if (Array.isArray(groupList)) {
      return groupList
        ?.find((group: any) => group.groupName == groupName)
        .categories?.map((category: any) =>
          category.categoryName.toLowerCase()
        );
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

/**
 * @description - Get category display names
 * @param {any} groupList - Category group list
 * @param {string} groupName - Selected group name
 * @returns {Array<string>}
 */
export const getCategoryDisplayNamesByGroup = (
  groupList: any,
  groupName: string
): Array<string> => {
  try {
    if (Array.isArray(groupList)) {
      return groupList
        ?.find((group: any) => group.groupName == groupName)
        .categories?.map((category: any) => category.displayName.toLowerCase());
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

/**
 * @description - Returns true if the category exists in the data array
 * @param {Array<any>} templates - template list
 * @param {any} groupId - template list
 * @param {any} categoryId - template list
 * @returns {boolean} - Returns true if the category exists if not false
 */
export const checkCategoryIdInGroupId = (
  templates: Array<any>,
  groupId: any,
  categoryId: any
): boolean => {
  if (isArray(templates)) {
    const group = _.find(templates, { groupId: groupId });
    if (!group) {
      return false;
    }
    return _.some(group.categories, { categoryId: categoryId });
  } else {
    return false;
  }
};
